import { createContext, useContext, useMemo } from "react";

export type DatePickerColor = "primary" | "secondary";

interface DatePickerContextType {
  color: DatePickerColor;
  readOnly: boolean;
  required: boolean;
  mode: "single" | "multiple" | "range";
}

const DatePickerContext = createContext<DatePickerContextType | undefined>(undefined);

export const useDatePickerCustomContext = () => {
  const context = useContext(DatePickerContext);
  if (context === undefined) {
    throw new Error("useDatePickerCustomContext must be used within a DatePickerProvider");
  }
  return context;
};

interface DatePickerProviderProps {
  children: React.ReactNode;
  color: DatePickerColor;
  readOnly: boolean;
  required: boolean;
  mode: "single" | "multiple" | "range";
}

export const DatePickerProvider = ({ children, color, readOnly, required, mode }: DatePickerProviderProps) => {
  const contextValue = useMemo(() => ({ color, readOnly, required, mode }), [color, readOnly, required, mode]);
  return <DatePickerContext.Provider value={contextValue}>{children}</DatePickerContext.Provider>;
};
